import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { addIcon } from '@europrocurement/l2d-icons';
import { FlexyButton } from '@europrocurement/flexy-components';

export type DossierFormaliteProcessesFooterProps = {
    canAddFormality: boolean;
    enablePublishButton: boolean;
    publishProcessing: boolean;
    showPublishButton: boolean;
    notPublishableReason?: string;
    onNavigateToValidation: () => void;
    onPublish: () => void;
    onAddFormality: () => void;
    onShowProcess?: () => void;
};

const DossierFormaliteProcessesFooter: React.FunctionComponent<DossierFormaliteProcessesFooterProps> =
    function (props) {
        const {
            canAddFormality,
            enablePublishButton,
            showPublishButton,
            publishProcessing,
            notPublishableReason,
            onNavigateToValidation: handleNavigateToValidation,
            onPublish: handlePublish,
            onAddFormality: handleAddFormality,
            onShowProcess: handleShowProcess,
        } = props;

        const wrapperSx = {
            display: 'flex',
            width: '100%',
            alignItems: 'center',
            paddingTop: '16px',
        };

        const endWrapperSx = {
            display: 'flex',
            alignItems: 'center',
            columnGap: '16px',
            marginLeft: 'auto',
            marginRight: 0,
        };

        const defaultBtnSx = {
            fontWeight: 500,
            padding: '8px 20px',
        };

        const publishButtonSx = {
            ...defaultBtnSx,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            columnGap: '8px',
        };

        return (
            <Box sx={wrapperSx}>
                {canAddFormality && (
                    <FlexyButton
                        key="add-formality-btn"
                        variant="text"
                        onClick={handleAddFormality}
                        icon={addIcon}
                        sx={publishButtonSx}
                    >
                        Ajouter une formalité
                    </FlexyButton>
                )}
                <Box sx={endWrapperSx}>
                    <FlexyButton
                        key="validate-btn"
                        onClick={handleNavigateToValidation}
                        sx={publishButtonSx}
                    >
                        Vérifier les informations
                    </FlexyButton>
                    {handleShowProcess && (
                        <FlexyButton
                            onClick={handleShowProcess}
                            sx={publishButtonSx}
                        >
                            Consulter mon dossier
                        </FlexyButton>
                    )}
                    {showPublishButton && (
                        <FlexyButton
                            disabled={publishProcessing || !enablePublishButton}
                            tooltip={notPublishableReason}
                            onClick={handlePublish}
                            sx={publishButtonSx}
                        >
                            {publishProcessing && <CircularProgress size="16px" />}
                            Déposer
                        </FlexyButton>
                    )}
                </Box>
            </Box>
        );
    };

export default DossierFormaliteProcessesFooter;
